<template>
  <div class="row">
    
    <div class="col-md-12">
      <div id="surveyCreatorContainer"></div>
    </div>

    <!-- Edit Modal -->
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">{{ $t('form_information') }}</h4>
      <ValidationObserver ref="formBuilderForm">
        <form>
          <ValidationProvider name="name" rules="required|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.title" :placeholder="$t('name')" :label="$t('form_name')"></fg-input>
          </ValidationProvider>
          <fg-input :label="$t('select_ngo')">
            <el-select size="large" class="select-primary" filterable clearable v-model="form.ngo_ID"
              :placeholder="$t('select_ngo')">
                <el-option
                  v-for="item in ngos"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
            </el-select>
          </fg-input>

          <fg-input :label="$t('select_country')">
            <el-select size="large" class="select-primary" filterable multiple clearable v-model="form.location_ID"
              :placeholder="$t('select_country')">
                <el-option
                  v-for="item in locations"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
            </el-select>
          </fg-input>
        </form>
      </ValidationObserver>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click="handleCloseModal">{{ $t('cancel') }}</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="info" link @click="updateForm">{{ $t('update_form') }}</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import * as SurveyCreator from "survey-creator";
import "survey-creator/survey-creator.css";
import Modal from "src/components/UIComponents/Modal.vue";

import Resource from "@/util/Api/resource.js";
const UpdateFormResource = new Resource("surveys/update");
const CategoryResource = new Resource("category");

export default {
  name: "edit-form",
  components: {
    Modal
  },
  data() {
    return {
      modals: {
        classic: false
      },
      formName: "",
      formId: null,
      formContent: "",
      form: {
         survey_id: '',
         title:'',
         formTemplate:'',
         ngo_ID:'',
         location_ID: [],
      },
      formData:{},
      categories: [],
      ngos:[],
      locations:[],
    };
  },

  created() {
      this.formData = this.$route.params.data;
      this.form.survey_id = this.formData.id;
      this.form.title = this.formData.title;
      this.form.ngo_ID = this.formData.ngo_id;
      this.form.location_ID = this.formData.location_ID;
      this.form.formTemplate = JSON.parse(this.formData.form_data);
      this.getCategories();
  },

  mounted() {
    SurveyCreator.StylesManager.applyTheme("bootstrap");

    let options = {};
    let vm = this;

    let surveyCreator = new SurveyCreator.SurveyCreator(
      "surveyCreatorContainer",
       options
    );

    surveyCreator.showToolbox = "right";
    surveyCreator.showPropertyGrid = "right";
    surveyCreator.rightContainerActiveItem("toolbox");
    surveyCreator.haveCommercialLicense = true;

    let page = surveyCreator.survey.pages[0];

    let pageData = this.form.formTemplate.pages;

    pageData.forEach(item => {
        page.fromJSON({
          name: item.name,
          title: item.title,
          description: item.description,
          elements: item.elements
        });
    });

    surveyCreator.saveSurveyFunc = function() {
         const formContent = JSON.parse(this.text);
         vm.openUpdateModal(formContent);
    };

  },

  methods: {
    // show message dialog
    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },

    // close modal method
    handleCloseModal() {
      this.modals.classic = false;
    },

    openUpdateModal(formContent) {
        this.modals.classic = true;
        this.formContent = formContent;
    },

    // getting all category
    async getCategories() {
      await CategoryResource.list({})
        .then(response => {
          this.categories = response.data;
          this.categories.forEach((value) => {
             if(value.id === 1) {
                value.children.forEach((element) => {
                   this.ngos.push(element);
                });
             } else if(value.id === 2){
                value.children.forEach((element) => {
                   this.locations.push(element);
                });
             }
          })
        })
        .catch(error => {
          console.log("error occured");
        });
    },

    // updating form template data
    async updateForm() {
      let form = new FormData();
      form.append("survey_id", this.form.survey_id);
      form.append("title", this.form.title);
      form.append("ngo_id", this.form.ngo_ID);
      form.append("location_ID", this.form.location_ID);
      form.append("formTemplate", JSON.stringify(this.formContent));

      await UpdateFormResource.store(form)
        .then(response => {
          this.$router.push({
              name: "FormBuilder"
          });
          this.showAlertMessage(this.$t("form_template_updated_successfully"), "success");
        })
        .catch(error => {
          if (error.response.data.error) {
            this.$refs.formBuilderForm.setErrors(
              error.response.data.error.message
            );
          }
        });
    }
  }
};
</script>
